const React = require("react")
const InterfaceOnline = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={57}
    height={46}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#0A645A"
        d="M6.667 16h30v-3.333h-30A3.343 3.343 0 0 0 3.333 16v18.333H0v5h23.333v-5H6.667V16Zm31.666 3.333h-10c-.916 0-1.666.75-1.666 1.667v16.667c0 .916.75 1.666 1.666 1.666h10c.917 0 1.667-.75 1.667-1.666V21c0-.917-.75-1.667-1.667-1.667Zm-1.666 15H30V22.667h6.667v11.666Z"
      />
    </g>
    <g clipPath="url(#b)">
      <path
        fill="#0A645A"
        d="m40.708 6.375 1.417 1.417a9.016 9.016 0 0 1 12.75 0l1.417-1.417c-4.3-4.3-11.277-4.3-15.584 0Zm5.667 5.667 2.125 2.125 2.125-2.125a3.001 3.001 0 0 0-4.25 0Zm-2.833-2.834 1.416 1.417a5.01 5.01 0 0 1 7.084 0l1.416-1.417c-2.734-2.734-7.175-2.734-9.916 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 6h40v40H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M40 0h17v17H40z" />
      </clipPath>
    </defs>
  </svg>
)
module.exports = {
  InterfaceOnline
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/cardButton/icons/interface-online.js